import { render, staticRenderFns } from "./auto-validation-tmc-review-page.vue?vue&type=template&id=05a44e25&scoped=true"
import script from "./auto-validation-tmc-review-page.vue?vue&type=script&lang=js"
export * from "./auto-validation-tmc-review-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a44e25",
  null
  
)

export default component.exports